import { createAction } from '@reduxjs/toolkit';

export const SET_ITINERARY = 'SET_ITINERARY';
export const setItinerary = createAction<any>(SET_ITINERARY);

export const UPDATE_ITINERARY = 'UPDATE_ITINERARY';
export const updateItinerary = createAction<any>(UPDATE_ITINERARY);
